<template>
  <el-table-column
    prop="category"
    sortable="custom"
    label="Kategória"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      <el-tag v-if="scope.row.category === 'normal'" size="small" type="info">Normál</el-tag>
      <el-tag v-if="scope.row.category === 'promotion'" size="small">Promóciós</el-tag>
      <el-tag v-if="scope.row.category === 'pos'" size="small" type="success">POS</el-tag>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'category',
  };
</script>
